import { $enum } from 'ts-enum-util'
import * as yup from 'yup'
import { TEMPERATURE_TYPE } from 'apps/fleet-planner/constants/loads'

export interface IShipmentTemperatureSetting {
  temperatureType?: TEMPERATURE_TYPE
  precool?: string | null
  minTemperature?: string | null
  maxTemperature?: string | null
  fixedTemperature?: string | null
}

export const TemperatureSettingsSchema = yup.object<IShipmentTemperatureSetting>({
  temperatureType: yup
    .mixed<TEMPERATURE_TYPE>()
    .oneOf([...$enum(TEMPERATURE_TYPE).getValues()])
    .default(TEMPERATURE_TYPE.fixed),
  precool: yup.string().nullable().default(null),
  minTemperature: yup.string().nullable().default(null),
  maxTemperature: yup.string().nullable().default(null),
  fixedTemperature: yup.string().nullable().default(null),
})
